// extracted by mini-css-extract-plugin
export default {"sortableAttributesContainer":"sortable-attributes-container__sortable-attributes-container__CW79P"};